var window=global;var $CLJS=require("./cljs_env");require("./cljs_env.js");
'use strict';var Oh=require("moment-timezone");module.exports=Oh;